import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'approvalStatus',
})
export class ApprovalStatusPipe implements PipeTransform {
  transform(item: any): string {
    let selectedName!: any;
    let allName: any = item.approvers?.split(',');
    if (item.confirmApproval) {
      selectedName = JSON.parse(item.confirmApproval);
    }
    return `${selectedName?.length ?? 0} of ${allName?.length ?? 0}`;
  }
}
